/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1SerieQueryResponse,
  GetApiV1SerieQueryParams,
  GetApiV1Serie401,
  GetApiV1Serie500,
} from "../../types/serieRegistroController/GetApiV1Serie.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1Serie } from "../../clients/serieRegistroController/getApiV1Serie.ts";

export const getApiV1SerieQueryKey = (params?: GetApiV1SerieQueryParams) =>
  [{ url: "/api/v1/serie" }, ...(params ? [params] : [])] as const;

export type GetApiV1SerieQueryKey = ReturnType<typeof getApiV1SerieQueryKey>;

export function getApiV1SerieQueryOptions(
  params?: GetApiV1SerieQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1SerieQueryKey(params);
  return queryOptions<
    GetApiV1SerieQueryResponse,
    ResponseErrorConfig<GetApiV1Serie401 | GetApiV1Serie500>,
    GetApiV1SerieQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1Serie(params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna uma lista paginada de séries. Filtra por tipo (Principal/Empresa/Todos) e por título. Usuários vinculados a uma empresa veem apenas as séries da própria empresa. **(Requer Authorization para autenticação)**
 * @summary Listar séries (Requer Authorization para autenticação)
 * {@link /api/v1/serie}
 */
export function useGetApiV1Serie<
  TData = GetApiV1SerieQueryResponse,
  TQueryData = GetApiV1SerieQueryResponse,
  TQueryKey extends QueryKey = GetApiV1SerieQueryKey,
>(
  params?: GetApiV1SerieQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1SerieQueryResponse,
        ResponseErrorConfig<GetApiV1Serie401 | GetApiV1Serie500>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey = resolvedOptions?.queryKey ?? getApiV1SerieQueryKey(params);

  const query = useQuery(
    {
      ...getApiV1SerieQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<GetApiV1Serie401 | GetApiV1Serie500>
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
